import { PublishedAssetType } from "@/graphql/generated/graphql";
import { createAssetUploadHandler } from "@/lib/tiptap-asset-upload";

export const MAX_PDF_FILE_SIZE = 10 * 1024 * 1024; // 10MB

// Takes the workspace rather than reading it globally because the editor is also
// rendered outside a workspace; without it the uploaded bytes are stored but
// attributed to no workspace.
export const createPdfUploadHandler = createAssetUploadHandler({
  maxFileSize: MAX_PDF_FILE_SIZE,
  assetType: PublishedAssetType.RichTextDocument,
  allowedMimeType: "application/pdf",
});
